// src/routes/MemberRoute.js
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { userService } from '../services/userService';

const MemberRoute = () => {
  const location = useLocation();
  const isAuthenticated = userService.isAuthenticated();

  if (!isAuthenticated) {
    // 로그인 페이지로 리다이렉트, 원래 가려던 경로 저장
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default MemberRoute;
